"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.reasoningOutcomeOf = reasoningOutcomeOf;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var REASONING_HEADINGS = {
  triggered: "Why this rule was triggered",
  "not-triggered": "Why this rule was not triggered",
  "not-run": "Why this rule was not run"
};
function reasoningOutcomeOf(match, stage) {
  if (stage === "skipped") return "not-run";
  if (match) return "triggered";
  return "not-triggered";
}
function IssueReasoning(_ref) {
  var text = _ref.text,
    outcome = _ref.outcome;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasOverflow = _useState4[0],
    setHasOverflow = _useState4[1];
  var textRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var checkOverflow = function checkOverflow() {
      var el = textRef.current;
      if (el) setHasOverflow(el.scrollHeight > el.clientHeight);
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return function () {
      return window.removeEventListener("resize", checkOverflow);
    };
  }, [text]);
  var handleClick = function handleClick() {
    if (hasOverflow) setIsExpanded(function (prev) {
      return !prev;
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    onClick: handleClick,
    onKeyDown: function onKeyDown(e) {
      if (!hasOverflow) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleClick();
      }
    },
    role: hasOverflow ? "button" : undefined,
    tabIndex: hasOverflow ? 0 : -1,
    "aria-expanded": isExpanded,
    className: (0, _utils.cn)("w-full gap-1 rounded-sm p-2 bg-background-card flex flex-col relative transition-all duration-200 ease-in-out box-border", isExpanded ? "min-h-0 cursor-default" : "min-h-20 cursor-pointer hover:bg-background-secondary-hover"),
    "data-sentry-component": "IssueReasoning",
    "data-sentry-source-file": "IssueReasoning.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "w-full flex flex-row items-center gap-2 justify-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex flex-1 items-center text-label-sm uppercase tracking-wide text-foreground-muted",
        children: REASONING_HEADINGS[outcome]
      }), hasOverflow && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
        "aria-label": isExpanded ? "Collapse" : "Expand",
        className: (0, _utils.cn)("transition-transform duration-200 ease-in-out shrink-0", isExpanded ? "rotate-180" : "rotate-0")
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: textRef,
      title: isExpanded ? undefined : text,
      className: (0, _utils.cn)("w-full box-border text-body text-foreground-primary flex-1 self-stretch mt-1", isExpanded ? "overflow-y-auto max-h-75" : "overflow-hidden line-clamp-3 text-ellipsis"),
      children: text
    })]
  });
}
var _default = exports.default = IssueReasoning;